import Joyride from 'react-joyride';
import React from 'react';
import Tooltip from '../../components/Tooltip';
import { green } from '../../styles/constants';

const GuidedTour = () => {
  const steps = [
    {
      title: 'Bloeiboog',
      content: 'De bloeiboog visualiseert de voedselbeschikbaarheid van de bijen op basis van de hoofdvliegtijd van de bijen en de bloeitijd van de planten. De bloeiboog is een slimme visualisatie die rekening houdt met het dieet van de bij.',
      target: '#flowering-arch',
    },
    {
      title: 'Voedseldekking',
      content: 'Een belangrijke bijbehorende term is de voedseldekking. De voedseldekking is uit te drukken in percentages en geeft aan of een gebied voldoende en diverse voedselbronnen beschikt om elke bij in elke vliegmaand te voeden.',
      target: '#flowering-arch-food-coverage',
    },
    {
      title: 'Bijenrij',
      content: 'De gekleurde hokjes illustreren de vliegtijd van de bij.',
      target: '#flowering-arch-bee-row',
    },
    {
      title: 'Voedseldiversiteit',
      content: 'Het cijfer in het hokje illustreert het aantal soorten planten waarop de bij zich in die maand kan voeden.',
      target: '#flowering-arch-flight-month',
    },
    {
      title: 'Uitleg verbergen?',
      target: '#flowering-arch-flight-month',
    },
  ];

  const showGuidedTour = localStorage.getItem('showGuidedTour');

  if (showGuidedTour === 'false') {
    return null;
  }

  return (
    <Joyride
      steps={steps}
      tooltipComponent={Tooltip}
      scrollToFirstStep
      continuous
      showProgress
      locale={{
        back: 'Terug', close: 'Sluiten', last: 'Vorige', next: 'Volgende', skip: 'Overslaan',
      }}
      spotlightPadding={0}
      styles={{
        options: {
          arrowColor: green,
          primaryColor: green,
        },
      }}
    />
  );
};

export default GuidedTour;
